export default "__VITE_ASSET__XbdJqPc7__"